// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import styles      from './style';
import ReactTable from "react-table";
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Dialog from 'material-ui/Dialog';

class BulkBookingList extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    const search = props.location.search; // returns the URL query String
    const params = new URLSearchParams(search);
    // const game = params.get('game_type')
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      start_date:moment(),
      end_date:moment(),
      customer_data:[],
      filtered_data:[],
      headers: [],
      search:'',
      loading: false,
      date_changed: false,
      bulk_booking_id:'',
      update_amount_dialog:false,
      bulk_booking_details:{},
      updated_amount:0,
      payment_mode:'',
      payment_modes:[],
      remaining_amount:0,
      net_amount:0
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getCustomers(this.state.venue,this.state.game_type);
    this.paymentModes()
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getCustomers() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=22221&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({customer_data:data.data,headers:data.headers, date_changed:false})
           // alert("fix");
       }).catch(error => error);
  }

  paymentModes(){
     const url = `${getLocationOrigin()}/eagleeye/get_payment_modes/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({payment_modes:data.payment_modes});
           // alert("fix");
       }).catch(error => error);
    }

  handleSearch(event){
    const search = event.target.value.toLowerCase()
    const filter_result = this.state.data.filter((venue)=>{
      return venue.name.toLowerCase().indexOf(search) !== -1;
      }
      );
    this.setState({filtered_data:filter_result,search:search})
  }

  handleStartDate(date) {
    this.setState({start_date:date,date_changed:true})
    this.getCustomers()
  }

  handleEndDate(date) {
    this.setState({end_date:date,date_changed:true})
    this.getCustomers()
  }

  editAmount(bulk_booking_id){
    console.log('bulk_booking_id',bulk_booking_id)
    let selected_bulk_booking = this.state.customer_data.find(each=> each[1] == bulk_booking_id)
    console.log(selected_bulk_booking)
    let net_amount_index = this.state.headers.indexOf('Net Amount')
    let remaining_amount_index = this.state.headers.indexOf('Remaining Amount')
    console.log('remaining_amount',{remaining_amount_index:selected_bulk_booking[remaining_amount_index]})
    console.log('net_amount',{net_amount_index:selected_bulk_booking[net_amount_index]})
    this.setState({update_amount_dialog:true,bulk_booking_id:bulk_booking_id,remaining_amount:selected_bulk_booking[remaining_amount_index],
      net_amount:selected_bulk_booking[net_amount_index],updated_amount:0});
  }

  handleClose = () => {
    this.setState({update_amount_dialog:false});
  };

  handleSubmit(event) {
    event.preventDefault();
    console.log('Submit');
    if(!this.state.remaining_amount){
      alert('There is no remaining amount')
    }
    else if(this.state.remaining_amount != this.state.updated_amount){
      alert('Amount should be equal to the remaining amount')
    }
    else{
      this.postUpdateAmount(this.props,this.state.bulk_booking_id,this.state.payment_mode,this.state.updated_amount)
    }
  }

  postUpdateAmount(props,bulk_booking_id,payment_mode,amount){
    // if(payment_mode==''){payment_mode = Object.keys(this.state.payment_modes)[0]}
    if(payment_mode == ''){
      alert('Please select payment mode')
    }
    else{
      const url = `${getLocationOrigin()}/court_booking/edit_bulk_booking/`;

      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'bulk_booking_id':bulk_booking_id,
                          'payment_mode':payment_mode,
                          'updated_amount':amount
                      });
      return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {        
          alert(response.message)
          location.reload()
          })
      .catch((error) => {
          console.log(error);
          alert(error.message);
          this.setState({update_amount_dialog:false})
      });
    }
  }

  handleChange(event){
    let value = event.target.value
    if(event.target.name == 'updated_amount'){
      this.setState({updated_amount:value})
    }
    else{
      this.setState({payment_mode:value})
    }
  }

  

  getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    };

  getTdProps = (state, rowInfo, column, instance) => {
    return {
      onClick: (e, handleOriginal) => {
          console.log(column)
          console.log('rowInfo',rowInfo)
          if(column.displayName === 'Edit'){
            this.setState({bulk_booking_id:rowInfo.row[1]},()=>{this.editAmount(rowInfo.row[1])} )
          }
        }
    }
  }

  renderCutsomers(){
   
    var headers = []
    if(this.state.customer_data.length > 0){
      headers = Object.keys(this.state.customer_data[0])
    }
    var temp_headers = this.state.headers

    const headings = this.state.headers.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = index.toString();//For react-table
      heading["displayName"] = element;
      heading["Header"] = element; //For react-table
      heading["sortable"] = true;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      return heading;
    });

    return(
      <div className='col-md-12 table_container1 table-responsive'>
        <div className="heading heading2 left">Bulk Booking List</div> 

        { this.state.headers.length > 0 ?
          <ReactTable  
                      data={this.state.customer_data}  
                      columns={headings}  
                      defaultPageSize = {25}  
                      pageSizeOptions = {[25,50,75,100]} 
                      filterable={true}
                      showPagination={this.state.customer_data.length > 25}
                      showPaginationTop = {this.state.customer_data.length > 25}
                      style = {{background:'#ddd'}}
                      getTrProps = {this.getTrProps}
                      getTdProps = {this.getTdProps}
                      defaultFilterMethod = {(filter, row, column) => {
                        const id = filter.pivotId || filter.id
                        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                      }}
          >
          {
                //To show the record count on top  
                (state, makeTable, instance) => {

                  let recordsInfoText = "";

                  const { filtered, pageRows, pageSize, sortedData, page } = state;

                  if (sortedData && sortedData.length > 0) {
                    let isFiltered = filtered.length > 0;

                    let totalRecords = sortedData.length;

                    let recordsCountFrom = page * pageSize + 1;

                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                    if (isFiltered){
                      recordsInfoText = `${totalRecords} filtered records`;
                    }
                    else {
                      recordsInfoText = `${totalRecords} records`;
                    }
                  } else {
                      recordsInfoText = "No records";
                    }
                  return (
                    <div className="main-grid" style={{background:'#ddd'}}>
                      <div className="above-table text-right">
                        <div className="col-sm-12 records-info">
                          <span className="">{recordsInfoText}</span>
                        </div>
                      </div>
                      {makeTable()}
                      
                    </div>

                  );
                }
              }
              </ReactTable>
          :
          <div style={{height:500}}>
            <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
          </div>
        }
      </div>
      )
  }

  render() {
    
    
    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;

    const dialog_actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Update Amount"
          primary={true}
          onClick={this.handleSubmit}
        />,
      ];
    
    console.log('props data',this.state)
    return(
      <div>
            <div className="breadcrumps" style={{marginBottom:'1%'}}>
                        <a href={'/#/partnerCourtBooking'}>
                          <span>Rental</span>
                        </a> 
                        <a >
                          <span>Bulkbookings</span>
                        </a> 
            </div>
            <div className='row' style={{textAlign:'center',padding:'1%'}}>
              <Link to={`./crud/addBulkBooking`} >
                        <FlatButton
                          backgroundColor="#ec407f"
                          className="flatbutton1"
                          label="Add Bulk Booking"
                          style={{float:'right',marginLeft: '5px',paddingleft:'1%',paddingright:'1%'}}
                        />
                      </Link>
            </div>
        
        <div>
          {this.renderCutsomers()}
          {
            this.state.update_amount_dialog ?
            <Dialog
                      actions={dialog_actions}
                      modal={false}
                      open={this.state.update_amount_dialog}
                      onRequestClose={this.handleClose}
                      autoDetectWindowHeight={true}
                      autoScrollBodyContent={true}
                      // scroll={scroll}
                      // dividers={scroll === 'paper'}
                    >

                <div style={{display:'flex',flexDirection:'column'}}>
                  <div style={styles.dialog_header} className="col-md-12">
                    <h4 style={{textAlign:'center'}}> Update Amount </h4>
                  </div>
                  <div className="col-md-12" style={{display:'flex',justifyContent:'space-between'}}>
                    <span style={styles.item_header}>Net Amount </span>
                    <span style={styles.item}>&#8377; {this.state.net_amount}</span>
                    <span style={styles.item_header}>Remaining Amount </span>
                    <span style={styles.item}>&#8377; {this.state.remaining_amount ? this.state.remaining_amount : 0}</span>
                  </div>
                  <div className="col-md-12" style={{marginTop:'2%'}}>
                    <div style={styles.item_header} className="col-md-6">
                      Amount
                    </div>
                    <input type="number" style={styles.input} className="required" name="updated_amount" value={this.state.updated_amount}
                          onChange={this.handleChange}/>
                  </div>
                  <div className="col-md-12" style={{marginTop:'2%'}}>
                    <div style={styles.item_header} className="col-md-6">
                      Payment Mode
                    </div>
                   <select name="payment_mode" className="col-md-6" style={styles.item_body} value={this.state.value}
                     onChange={this.handleChange}>
                      <option>--select--</option>
                      {
                         Object.keys(this.state.payment_modes).map((key, index) => (
                         <option key={key} value={key}>{`${this.state.payment_modes[key]}`}</option>
                         ))
                       }
                    </select>
                  </div>
                </div>
              </Dialog>
              :
              ""
          }
        </div>
      </div>
    );
  }
}

export default BulkBookingList;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/bulkBookingList/BulkBookingList.js